import React, {Fragment} from 'react';
import { Navbar } from 'react-bootstrap';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../logo_pogo2.png'

const NavBar = (props) => {
return (
<Navbar bg="dark" variant="dark">
    <Navbar.Brand>
      <img
        alt=""
        src={logo}
        width="35"
        height="30"
        className="d-inline-block align-top"
      />{' '}
      Charty McChart Chart
    </Navbar.Brand>
  </Navbar>
)

}

export default NavBar;